// extracted by mini-css-extract-plugin
module.exports = {"melodyVideo":"Me-z","landingPageVideo":"Ne-z","play":"Oe-z","iframeVideo":"Pe-z","playHidden":"Qe-z","fullwidth":"Re-z"};